import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-136c17e2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "information"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "container-left"
};
var _hoisted_4 = {
  class: "container-right"
};
import Nav from '@/components/Nav/index.vue';
import NavSearch from '@/components/Nav/NavSearch.vue';
import Footer from '@/components/Footer/index.vue';
import { useRoute, useRouter } from 'vue-router';
import { ref, reactive, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var menuList = reactive([{
      index: 1,
      url: '/information/account',
      title: 'Account Information'
    }, {
      index: 2,
      url: '/information/subscriptions',
      title: 'Subscriptions Information'
    }, {
      index: 3,
      url: '/information/download-records',
      title: 'Download records'
    }, {
      index: 4,
      url: '/information/viewed-records',
      title: 'View Records'
    }, {
      index: 5,
      url: '/information/save-list',
      title: 'Save List'
    }, {
      index: 6,
      url: '/information/monitoring-lists',
      title: 'Monitoring List'
    }, {
      index: 7,
      url: '/information/receipts',
      title: 'Receipts'
    }]); // 高亮的path是哪一个

    var currentPath = ref(route.path); // 监听路由变化

    watch(function () {
      return route.path;
    }, function (newVal) {
      var _ref = route.meta || {},
          activeMenu = _ref.activeMenu; // 高亮的


      if (activeMenu) {
        return currentPath.value = activeMenu;
      }

      currentPath.value = newVal;
    }, {
      immediate: true
    }); // nav Search

    function handleNavSearch(data) {
      router.push({
        name: 'Search',
        query: {
          key: data.entityName,
          code: data.countryCode
        }
      });
    }

    return function (_ctx, _cache) {
      var _component_document = _resolveComponent("document");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_router_link = _resolveComponent("router-link");

      var _component_el_menu = _resolveComponent("el-menu");

      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Nav, null, {
        search: _withCtx(function () {
          return [_createVNode(NavSearch, {
            onSearch: handleNavSearch
          })];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_menu, {
        "default-active": currentPath.value,
        class: "el-menu-vertical-demo"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), function (item) {
            return _openBlock(), _createBlock(_component_router_link, {
              to: item.url,
              key: item.index
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_el_menu_item, {
                  index: item.url
                }, {
                  title: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item.title), 1)];
                  }),
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_icon, null, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_document)];
                      }),
                      _: 1
                    })];
                  }),
                  _: 2
                }, 1032, ["index"])];
              }),
              _: 2
            }, 1032, ["to"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["default-active"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view)])]), _createVNode(Footer)]);
    };
  }
});